export enum JourneyRoutes {
  LANDING_PAGE = "fahrzeugdaten",
  LICENSES = "licenses",
  ERROR = "error"
}